export default class NetworkError extends Error {
	constructor(code, data) {
		super('Network Error');

		this.type = 'NETWORK';
		this.code = code;
		this.data = data;
	}
}
